import { render, staticRenderFns } from "./UserFieldAutoApproveExtra.vue?vue&type=template&id=1fc59e44&scoped=true"
import script from "./UserFieldAutoApproveExtra.vue?vue&type=script&lang=js"
export * from "./UserFieldAutoApproveExtra.vue?vue&type=script&lang=js"
import style0 from "./UserFieldAutoApproveExtra.vue?vue&type=style&index=0&id=1fc59e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc59e44",
  null
  
)

export default component.exports